// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-title {
  color: #595959 !important;
  font-size: 0.8vw !important;
  line-height: 1.1vw !important;
  letter-spacing: -0.020vw !important;
  font-family: "Poppins" !important;
  font-weight: 600 !important;
}

.modal-close {
  height: 1.4vw;
  width: 1.4vw;
  border: .05vw solid #8b8b8b;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.2vw;
  cursor: pointer;
}

.modal-data {
  color: #101010 !important;
  font-size: .7vw !important;
  line-height: 100% !important;
  font-family: "Poppins" !important;
  font-weight: 700 !important;
}

.action-modal-label {
  display: flex !important;
  /* flex-direction: column !important; */
  flex-direction: row-reverse !important;
  justify-content: space-between !important;
  margin: 0.3vw 0 !important;
}

.close-section{
  display: flex;
  column-gap: 0.5vw;
}

.addField {
  color:#50C878;
  font-size: 0.6vw;
  font-family: "Poppins";
  padding:0.25vw 0.5vw;
  border:0.05vw solid #50C878;
  height: 1.4vw;
  min-width: 3.3vw;
  max-width: fit-content;
  border-radius: 0.15vw;
  cursor: pointer;
  &:active{
    background-color: #50C878;
    color:white; 
  }
}

.fixed-modal-height {
  max-height: 6.2vw;
  overflow-y: scroll;

}

.input-section {
  /* border:0.05vw solid red; */
  display: flex;
  align-items: center;
  column-gap: 0.5vw;
  margin-bottom: 0.5vw;
}

.input-section input {
  flex:1 1;
  height: 2.3vw;
  border-radius: 0.4vw;
  border:none;
  background-color: #D9D9D9;
  padding: 0.55vw 0vw 0.55vw 0.98vw;
  font-family: "Poppins";
  font-weight: 500;
  font-size: 0.8vw;
}

.input-section button{
  border: 0.05vw solid #F23D3D;
  height:1.75vw;
  width: 1.75vw;
  padding: 0.25vw 0.5vw;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.15vw;
  &:active{
    background-color: #f23d3d7a;
  }
}

.footer-btn-grp{
  display: flex;
  column-gap: 0.8vw;
}

.footer-btn-grp button {
  width: 8.5vw;
  height: 2.0vw;
  padding: 0.45vw 0.20vw;
  text-transform: uppercase;
  font-family: "Poppins";
  font-weight: 600;
  font-size: 0.7vw;
  border-radius: 0.25vw;
  cursor: pointer;
}

.footer-btn-grp .btn-1 {
  border:0.05vw solid #8B8B8B;
  background-color: transparent;  
  color: #8B8B8B;
  transition: all 0.2s ease;
  &:active{
    background-color: #8b8b8b9d;
    color:white;
    border:0.05vw solid #8b8b8b9d;
  }
}

.footer-btn-grp .btn-2 {
  border:none;
  background-color: #50C878; 
  color: #000000;
  transition: all 0.2s ease;
  &:active{
    background-color: #50c87898;
  }
}

.phone-wrapper {
  background-color: #D9D9D9;
  display: flex;
  align-items:center ;
  padding: 0vw 0vw 0vw 0.82vw;
  height: 2.3vw;
  width: 100%;
  border-radius: 0.4vw;
}

.phone-wrapper span{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 0.7vw;
  width: 1vw;
}

.phone-box {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 0.7vw;
  width: 100%;
}

.phone-box span{
  color: #8B8B8B;
  position: absolute;
  white-space: nowrap;
  font-size: 0.8vw;
  font-family: "Poppins";
  font-weight: 500; 
  display: flex;
  
  /* z-index: -1;  */
}

 .phone-box .react-tel-input .form-control{
  background-color: transparent !important;
  padding-left: 0.5vw !important;
  border: none;
  width: 100% !important;
  font-size: 0.8vw;
  font-family: "Poppins";
  font-weight: 500;
}

.phone-box .react-tel-input .flag-dropdown {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/modals/ordersModal/actionModalStyle.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,mCAAmC;EACnC,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;EACvC,sCAAsC;EACtC,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf;IACE,yBAAyB;IACzB,WAAW;EACb;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;;AAEpB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,QAAM;EACN,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,yBAAyB;EACzB,iCAAiC;EACjC,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB;IACE,2BAA2B;IAC3B,WAAW;IACX,6BAA6B;EAC/B;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;;EAEb,kBAAkB;AACpB;;CAEC;EACC,wCAAwC;EACxC,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".modal-title {\n  color: #595959 !important;\n  font-size: 0.8vw !important;\n  line-height: 1.1vw !important;\n  letter-spacing: -0.020vw !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 600 !important;\n}\n\n.modal-close {\n  height: 1.4vw;\n  width: 1.4vw;\n  border: .05vw solid #8b8b8b;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 0.2vw;\n  cursor: pointer;\n}\n\n.modal-data {\n  color: #101010 !important;\n  font-size: .7vw !important;\n  line-height: 100% !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 700 !important;\n}\n\n.action-modal-label {\n  display: flex !important;\n  /* flex-direction: column !important; */\n  flex-direction: row-reverse !important;\n  justify-content: space-between !important;\n  margin: 0.3vw 0 !important;\n}\n\n.close-section{\n  display: flex;\n  column-gap: 0.5vw;\n}\n\n.addField {\n  color:#50C878;\n  font-size: 0.6vw;\n  font-family: \"Poppins\";\n  padding:0.25vw 0.5vw;\n  border:0.05vw solid #50C878;\n  height: 1.4vw;\n  min-width: 3.3vw;\n  max-width: fit-content;\n  border-radius: 0.15vw;\n  cursor: pointer;\n  &:active{\n    background-color: #50C878;\n    color:white; \n  }\n}\n\n.fixed-modal-height {\n  max-height: 6.2vw;\n  overflow-y: scroll;\n\n}\n\n.input-section {\n  /* border:0.05vw solid red; */\n  display: flex;\n  align-items: center;\n  column-gap: 0.5vw;\n  margin-bottom: 0.5vw;\n}\n\n.input-section input {\n  flex:1;\n  height: 2.3vw;\n  border-radius: 0.4vw;\n  border:none;\n  background-color: #D9D9D9;\n  padding: 0.55vw 0vw 0.55vw 0.98vw;\n  font-family: \"Poppins\";\n  font-weight: 500;\n  font-size: 0.8vw;\n}\n\n.input-section button{\n  border: 0.05vw solid #F23D3D;\n  height:1.75vw;\n  width: 1.75vw;\n  padding: 0.25vw 0.5vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 0.15vw;\n  &:active{\n    background-color: #f23d3d7a;\n  }\n}\n\n.footer-btn-grp{\n  display: flex;\n  column-gap: 0.8vw;\n}\n\n.footer-btn-grp button {\n  width: 8.5vw;\n  height: 2.0vw;\n  padding: 0.45vw 0.20vw;\n  text-transform: uppercase;\n  font-family: \"Poppins\";\n  font-weight: 600;\n  font-size: 0.7vw;\n  border-radius: 0.25vw;\n  cursor: pointer;\n}\n\n.footer-btn-grp .btn-1 {\n  border:0.05vw solid #8B8B8B;\n  background-color: transparent;  \n  color: #8B8B8B;\n  transition: all 0.2s ease;\n  &:active{\n    background-color: #8b8b8b9d;\n    color:white;\n    border:0.05vw solid #8b8b8b9d;\n  }\n}\n\n.footer-btn-grp .btn-2 {\n  border:none;\n  background-color: #50C878; \n  color: #000000;\n  transition: all 0.2s ease;\n  &:active{\n    background-color: #50c87898;\n  }\n}\n\n.phone-wrapper {\n  background-color: #D9D9D9;\n  display: flex;\n  align-items:center ;\n  padding: 0vw 0vw 0vw 0.82vw;\n  height: 2.3vw;\n  width: 100%;\n  border-radius: 0.4vw;\n}\n\n.phone-wrapper span{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 0.7vw;\n  width: 1vw;\n}\n\n.phone-box {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 0.7vw;\n  width: 100%;\n}\n\n.phone-box span{\n  color: #8B8B8B;\n  position: absolute;\n  white-space: nowrap;\n  font-size: 0.8vw;\n  font-family: \"Poppins\";\n  font-weight: 500; \n  display: flex;\n  \n  /* z-index: -1;  */\n}\n\n .phone-box .react-tel-input .form-control{\n  background-color: transparent !important;\n  padding-left: 0.5vw !important;\n  border: none;\n  width: 100% !important;\n  font-size: 0.8vw;\n  font-family: \"Poppins\";\n  font-weight: 500;\n}\n\n.phone-box .react-tel-input .flag-dropdown {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
